import { render, staticRenderFns } from "./PointPriceApply.vue?vue&type=template&id=7d72a19a&scoped=true"
import script from "./PointPriceApply.vue?vue&type=script&lang=js"
export * from "./PointPriceApply.vue?vue&type=script&lang=js"
import style0 from "./PointPriceApply.vue?vue&type=style&index=0&id=7d72a19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d72a19a",
  null
  
)

export default component.exports